var en_BORK = {};
module['exports'] = en_BORK;
en_BORK.title = "Bork (English)";
en_BORK.lorem = require("./lorem");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/en_BORK/index.js
 ** module id = 384
 ** module chunks = 0
 **/